import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import { pageAccessApi } from '@nami/apis'
import { PageEnum, parsePageEnum } from '@nami/domain/enums'
import { GetLocalStorage } from '@/composable/useLocalStorage'

export default async function pageAccessValidator({
    next,
    to,
}: {
    next: NavigationGuardNext
    to: RouteLocationNormalized
}) {
    const isSkipAddNewBank = GetLocalStorage('SkipAddNewBank') === 'y'
    const isApp = GetLocalStorage('Device') === 'app'
    const pageEnum = parsePageEnum(to.name)
    const { isOk, page } = await pageAccessApi(pageEnum, isSkipAddNewBank)

    // return next();
    if (isOk) {
        return next()
    }
    else {
        const pageName = PageEnum[page].toLowerCase()
        if (isApp) {
            return next({ name: pageName, query: { pf: 'app' } })
        }
        return next({ name: pageName })
    }
}
